import { lazy } from 'react'

export const Home = lazy(() =>
  import('../../views/private/home/index.tsx').then((module) => ({ default: module.Home }))
)

export const Friends = lazy(() =>
  import('../../views/private/friends/index.tsx').then((module) => ({ default: module.Friends }))
)

export const Chat = lazy(() =>
  import('../../views/private/chat/index.tsx').then((module) => ({ default: module.Chat }))
)

export const Requests = lazy(() =>
  import('../../views/private/requests/index.tsx').then((module) => ({ default: module.Requests }))
)

export const Calendar = lazy(() =>
  import('../../views/private/calender/index.tsx').then((module) => ({
    default: module.Calendar,
  }))
)

export const Profile = lazy(() =>
  import('../../views/private/profile/index.tsx').then((module) => ({ default: module.Profile }))
)

export const Map = lazy(() =>
  import('../../views/private/map/index.tsx').then((module) => ({ default: module.Map }))
)

export const Settings = lazy(() =>
  import('../../views/private/settings/index.tsx').then((module) => ({
    default: module.Settings,
  }))
)
